import { Component, OnInit } from '@angular/core';
import { PensionDataService } from './../../services/pension-data.service';

@Component({
  selector: 'app-get-data',
  templateUrl: './get-data.component.html',
  styleUrls: ['./get-data.component.scss']
})
export class GetDataComponent implements OnInit {
  pensions;
  constructor(private pds:PensionDataService) { }

  ngOnInit() {
    this.pds.currentMessage.subscribe(kk=>this.pensions=kk);
    var ll = 0;
  }

}

